import swal from 'sweetalert2/dist/sweetalert2.all.min.js'
import { swalError } from '../components/Swaler'

export default (state = {}, action) => {

    switch (action.type) {
        case "FEEDBACK_SUCCESS":
            swal.fire({
                // position: 'top-right',
                type: 'success',
                title: 'Sparat',
                showConfirmButton: false,
                timer: 1500
            })
            break

        case "FEEDBACK_ERROR":
            swal.fire({
                title: '',
                text: `${action.payload}`,
                type: 'error',
                confirmButtonColor: '#006e78',
            })
            break

        case "ALLOCATE_FAIL":
            console.log(action.payload)
            swalError(action.payload)
            break
    }

    return { ...state }
}